/*
 * Created Date: 20-01-2024, 11:45:31 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Mon Jan 22 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { useStorage } from '@Core/hooks'
import moment from 'moment'
import { createContext, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import momentVi from 'moment/locale/vi'

const MultiLanguageContext = createContext({
	lng: 'vi',
	handleChangeLanguage: lng => null
})

export const useMultiLanguageContext = () => useContext(MultiLanguageContext)
moment.locale('vi')
// console.log('============= momentVi', momentVi)
const MultiLanguageProvider = props => {
	// console.log('============= moment', moment.locale())
	const {
		i18n: { changeLanguage, language }
	} = useTranslation()

	const [lng, setLng] = useStorage({ key: 'lng', initValue: 'vi', store: 'local' })

	const handleChangeLanguage = lng => {
		setLng(lng)
	}

	useEffect(() => {
		if (language !== lng) {
			changeLanguage(lng)
		}
	}, [lng, language, changeLanguage])

	const languageDirection = {
		vi: 'ltr',
		en: 'ltr'
	}

	const languageCacheStyle = languageDirection[lng]

	return (
		<MultiLanguageContext.Provider value={{ lng, languageCacheStyle, handleChangeLanguage }}>
			{props.children}
		</MultiLanguageContext.Provider>
	)
}

export default MultiLanguageProvider
